/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, h } from './index-ef0fa435.js';

const WeatherItem = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.icon = undefined;
    this.name = undefined;
    this.value = undefined;
    this.rotateIcon = undefined;
  }
  render() {
    return [
      h("lar-list-item", null, h("div", { slot: "start", class: "circle" }, h("lar-icon", { color: "tertiary", style: { transform: `rotate(${this.rotateIcon || 0}deg)` }, icon: this.icon })), h("h4", null, h("lar-translate", { t: this.name })), this.value !== 'true' && this.value !== 'false' && h("span", null, this.value), (this.value === 'true' || this.value === 'false') && h("span", null, h("lar-translate", { t: `weather.${this.value}` })))
    ];
  }
};

export { WeatherItem as lar_weather_item };

//# sourceMappingURL=lar-weather-item.entry.js.map